import { render, staticRenderFns } from "./hindex-confirm.dialog.vue?vue&type=template&id=47c8a60b&scoped=true"
import script from "./hindex-confirm.dialog.vue?vue&type=script&lang=js"
export * from "./hindex-confirm.dialog.vue?vue&type=script&lang=js"
import style0 from "./hindex-confirm.dialog.vue?vue&type=style&index=0&id=47c8a60b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47c8a60b",
  null
  
)

export default component.exports